<script setup lang="ts">
import type {
  IconSize,
  TpgClickEvent,
  TpgInputEvent,
} from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';

export interface GrammarQuaternaryButtonToggleProps {
  activated?: boolean;
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  iconTemplate?: IconConstant | '';
  iconPosition?: 'leading' | 'trailing' | 'top';
  iconOnlySize?: IconSize;
  size?: 'x-small' | 'small' | 'regular' | 'overlay';
  selected?: boolean;
}

const props = withDefaults(defineProps<GrammarQuaternaryButtonToggleProps>(), {
  activated: false,
  label: '',
  ariaLabel: '',
  disabled: false,
  iconTemplate: '',
  iconPosition: 'leading',
  iconOnlySize: 'large',
  size: 'regular',
  selected: false,
});

const emit = defineEmits(['click', 'input']);

function onClick(event: TpgClickEvent) {
  emit('click', event);
}

function onInput(event: TpgInputEvent<boolean>) {
  emit('input', event);
}
</script>

<template>
  <tpg-quaternary-button-toggle
    v-bind="props"
    @tpg-click="onClick"
    @tpg-input="onInput"
  />
</template>
